export const ScarFieldLabels = {
  description: 'Problem Description',
  rootCause: 'Root Cause',
  containmentAction: 'Containment Action',
  containmentCompletedDate: 'Containment Completion Date',
  permanentCorrectiveAction: 'Permanent Corrective Action',
  premanentCorrectiveActionDate: 'Permanent Corrective Action Date',
  correctiveActionVerification: 'Verification of Corrective Action',
  attachments: 'Evidence of effectiveness',
  taskFiles: 'Document References'
} as const;

export type ScarField = keyof typeof ScarFieldLabels;

export const ScarFields: ScarField[] = Object.keys(
  ScarFieldLabels
) as ScarField[];
